module.exports = __webpack_public_path__ + "icon-128-visualisation-polararea.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-128-visualisation-polararea.png
// module id = 633
// module chunks = 11